<template>
  <div class="py-2 px-4 my-2">
    <vs-row v-if="editQuestion">
      <vs-col class="mt-2">
        <div>
          <h5 class="heading-black text-left font-semibold text-lg my-2">
            Question
          </h5>

          <vs-textarea
            placeholder="Enter your question here"
            name="question"
            class="w-full text-lg rounded mb-0 p-2"
            v-model="selectedQuestion.question"
          />
        </div>
      </vs-col>

      <vs-col class="mt-2">
        <div>
          <h5 class="heading-black text-left font-semibold text-lg my-2">
            Answer A
          </h5>
          <div>
            <input
              name="AssignmentUrl"
              class="p-2 w-full text-xl url-input rounded"
              v-model="selectedQuestion.optionA"
            />
          </div>
        </div>
      </vs-col>

      <vs-col class="mt-2">
        <div>
          <h5 class="heading-black text-left font-semibold text-lg my-2">
            Answer B
          </h5>
          <div>
            <input
              name="AssignmentUrl"
              class="p-2 w-full text-xl url-input rounded"
              v-model="selectedQuestion.optionB"
            />
          </div>
        </div>
      </vs-col>

      <vs-col class="mt-2">
        <div>
          <h5 class="heading-black text-left font-semibold text-lg my-2">
            Answer C
          </h5>
          <div>
            <input
              name="AssignmentUrl"
              class="p-2 w-full text-xl url-input rounded"
              v-model="selectedQuestion.optionC"
            />
          </div>
        </div>
      </vs-col>

      <vs-col class="mt-2">
        <div>
          <h5 class="heading-black text-left font-semibold text-lg my-2">
            Answer D
          </h5>
          <div>
            <input
              name="AssignmentUrl"
              class="p-2 w-full text-xl url-input rounded"
              v-model="selectedQuestion.optionD"
            />
          </div>
        </div>
      </vs-col>

      <vs-col class="mt-2">
        <div>
          <h5 class="heading-black text-left font-semibold text-lg my-2">
            Correct Answer
          </h5>
          <div>
            <v-select
              v-validate="'required'"
              v-model="selectedQuestion.answerChosen"
              :options="selectedQuestion.choices"
            />
          </div>
        </div>
      </vs-col>

      <div class="flex flex-row place-content-end w-full gap-x-4 mt-6 mb-0">
        <div
          @click="editQuestion = false"
          class="w-fit btn-claim text-base font-semibold rounded-lg py-2 px-4 cursor-pointer text-black border-black border-2 border-opacity-50"
        >
          Cancel
        </div>

        <div
          @click="saveChanges"
          :style="{ background: orgData.primaryThemeColor }"
          class="w-fit btn-claim text-base font-semibold rounded-lg py-2 px-4 cursor-pointer text-white border-black border-opacity-0 border-2"
        >
          Save
        </div>
      </div>
    </vs-row>
    <div v-else>
      <h4 class="heading-black font-semibold text-left mb-4">
        {{ index + 1 }}) {{ question.question }}
      </h4>
      <div
        class="flex mt-2"
        v-for="(option, i) in question.choices"
        :key="option.key"
      >
        <vs-radio
          v-model="ansChosen"
          :vs-value="option.key"
          :vs-name="option.key"
        >
          <span class="ml-2 question-box-option">{{ numToAplha(i) }})</span>
          <span class="question-box-option">
            {{ option.label }}
          </span>
        </vs-radio>
      </div>

      <div v-if="ansChosen" class="flex items-left mt-3">
        <h4
          class="text-lg font-semibold heading-red"
          v-if="ansChosen !== selectedQuestion.answer"
        >
          Whoops! Try again
        </h4>
        <h4
          class="text-lg font-semibold heading-correct"
          v-if="ansChosen === selectedQuestion.answer"
        >
          Correct!
        </h4>
      </div>
    </div>

    <hr v-if="!editQuestion" class="mt-6 mb-4" />
    <div
      v-if="!editQuestion"
      class="mt-0 flex flex-row justify-end place-content-end align-bottom gap-x-4 mb-0"
    >
      <vs-button class="bg-transparent p-0" @click="editQuestion = true"
        ><img class="w-5 h-5" src="@/assets/images/edit-icon.svg"
      /></vs-button>
      <vs-button class="bg-transparent p-0" @click="deleteQues(question._id)"
        ><img class="w-5 h-5" src="@/assets/images/trash-icon.svg"
      /></vs-button>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      ansChosen: "",
      selectedQuestion: {
        question: "",
        optionA: "",
        optionB: "",
        optionC: "",
        optionD: "",
        answerChosen: "",
        choices: [{ key: "", label: "Please Select" }],
        answer: {},
        questionType: {},
      },
      editQuestion: false,
    };
  },
  components: {
    vSelect,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
  },
  watch: {
    "selectedQuestion.optionA": "updateOptions",
    "selectedQuestion.optionB": "updateOptions",
    "selectedQuestion.optionC": "updateOptions",
    "selectedQuestion.optionD": "updateOptions",
  },
  mounted() {
    this.selectedQuestion = { ...this.question };
  },
  methods: {
    updateOptions() {
      this.selectedQuestion.choices = [
        {
          key: `q${this.index + 1}_optionA`,
          label: this.selectedQuestion.optionA,
        },
        {
          key: `q${this.index + 1}_optionB`,
          label: this.selectedQuestion.optionB,
        },
        {
          key: `q${this.index + 1}_optionC`,
          label: this.selectedQuestion.optionC,
        },
        {
          key: `q${this.index + 1}_optionD`,
          label: this.selectedQuestion.optionD,
        },
      ];
    },
    numToAplha(index) {
      if (index >= 0 && index < 26) {
        return String.fromCharCode("A".charCodeAt(0) + index);
      } else {
        return null;
      }
    },
    deleteQues(quesId) {
      this.$store
        .dispatch("organization/deleteQuestion", quesId)
        .then((res) => {
          if (res.code === "QUIZ_QUESTION_DELETED_SUCCESSFULLY") {
            this.$emit("deleteQues", this.index);
          }
        })
        .catch(() => {});
    },
    saveChanges() {
      this.$emit("editQues", {
        index: this.index,
        updatedQues: this.selectedQuestion,
      });
      this.editQuestion = false;
    },
  },
};
</script>

<style lang="scss" scoped>
span {
  color: #948f8f;
}
.con-vs-radio ::v-deep .vs-radio--label {
  text-align: left;
}
.heading {
  &-black {
    color: #000000 !important;
  }
  &-gray {
    color: #948f8f !important;
  }
  &-red {
    color: #ff6584 !important;
  }
  &-correct {
    color: #4ade80 !important;
  }
}
.url-input {
  border: 1px solid rgba(60, 60, 60, 0.26);
}
</style>
